export default __webpack_public_path__ + "static/media/3_003.268e0d10.png";